import { Budget } from '../../../../@types/budget';
import { ChildService } from '../../../../@types/order-service';
import { maskCpfCnpj, maskPhone } from '../../../../services/helpers/mask';
import { ServiceDTO } from '../../OrderService/CreateOrderServiceForm/OrderServiceDTO';
import {
  isValidService,
  mapChildServices,
  parseNumber,
} from '../../OrderService/CreateOrderServiceForm/parseOrderServiceForm';
import { CreateBudgetInput } from '../CreateBudgetForm/interfaces';
import { BudgetFormDTO } from './BudgetFormDTO';

/**
 * Converte os valores do formulário para o formato aceito no envio do orçamento.
 * @param formValues - Dados do formulário do Orçamento.
 * @returns Objeto formatado para a criação do Orçamento.
 */
export const parseBudgetForm = (
  formValues: BudgetFormDTO,
  total: number,
): CreateBudgetInput => {
  const { customer, services, vehicle } = formValues;

  const productTable = mapChildServices(
    services.productTable,
    'Produto',
  ).filter(service => isValidService(service));
  const serviceTable = mapChildServices(
    services.serviceTable,
    'Serviço',
  ).filter(service => isValidService(service));

  const child_services: ChildService[] = [...productTable, ...serviceTable];

  const result: CreateBudgetInput = {
    // cliente
    comment: services.comment,
    discount: parseNumber(services.discount, true),
    document: customer.document,
    name: customer.name,
    phone: customer.phone,
    // serviços
    child_services,
    image_urls: services.images_urls,
    validity: services.validity.length > 0 ? services.validity : '7 dias',
    total,
  };

  // veículo
  if (vehicle.plate) {
    result.km = parseNumber(vehicle.km.replaceAll('.', ''));
    result.plate = vehicle.plate;
    result.chassi = vehicle.chassi;
    result.vehicle = vehicle.vehicle;
  }
  return result;
};

export const mapRepairToFormValues = (res: Budget): BudgetFormDTO => {
  const serviceTable: ServiceDTO[] = [];
  const productTable: ServiceDTO[] = [];

  (res?.child_services ?? []).forEach(childService => {
    const name = childService?.name ?? '';
    const quantity = Number(childService?.quantity ?? 0);
    const total = Number(childService?.total ?? 0);
    const unitValue = (quantity > 0 ? total / quantity : 0)
      .toFixed(2)
      .replace('.', ',');

    const item: ServiceDTO = {
      name,
      quantity: quantity.toString(),
      unitValue,
      total: total.toString(),
    };

    if (childService.type === 'Serviço') {
      serviceTable.push(item);
    } else {
      productTable.push(item);
    }
  });

  const parsed: BudgetFormDTO = {
    id_budget: res?.id_budget ?? '',
    vehicle: {
      km: `${res.vehicle ? res?.km ?? 0 : ''}`,
      lastKm: `${res?.km ?? 0}`,
      vehicle: res?.vehicle ?? '',
      plate: res?.plate ?? '',
      chassi: res?.chassi ?? '',
    },
    customer: {
      document: maskCpfCnpj(res?.document ?? ''),
      name: res?.name ?? '',
      phone: maskPhone(res?.phone ?? ''),
    },
    services: {
      comment: res?.comment ?? '',
      images_urls: res?.images.map(banner => banner.img_url) ?? [],
      discount: `${(res?.discount ?? 0).toFixed(2).replace('.', ',')}`,
      productTable,
      serviceTable,
      total: `${res?.total ?? 0}`,
      validity: res?.validity ?? '7 dias',
    },
  };

  return parsed;
};
